export const BRIDGE_BAR_COLOR = '#FF4378';
export const MIN_BRIDGE_BAR_HEIGHT_PX = 1;
export const BAR_WIDTH = 85;
export const BAR_HORIZONTAL_PADDING_MIN = 16;
export const BAR_WIDTH_NARROW = 70;
export const BAR_HORIZONTAL_PADDING_NARROW = 18;

export const AXIS_LABEL_FONT_SIZE = 12;
export const Y_AXIS_GRID_GAP = 16;
export const Y_AXIS_CHAR_WIDTH = 6.5;
export const Y_AXIS_PADDING = 4;
export const Y_AXIS_LABEL_EXTRA_WIDTH = 8;
export const CHART_HEIGHT = 500;
export const CHART_TOP_MARGIN = 8;

export const MIN_COLUMN_SLOT_WIDTH_NARROW =
  BAR_WIDTH_NARROW + BAR_HORIZONTAL_PADDING_NARROW * 2;
export const MIN_COLUMN_SLOT_WIDTH = BAR_WIDTH + BAR_HORIZONTAL_PADDING_MIN * 2;

export const PDF_BAR_WIDTH_RATIO = 0.45;
